import axios from './configAxios';

export const getOrdersApi = async (url, filter) => {
	console.log(url);
	return await axios.get(`${url}`);
	// return await axios.get(`/${filter}`);
};
